import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const StatusContratoList = (props) => <DefaultDataTable data={props} />
